// @ts-nocheck
import React from "react";
import { MenuDesplegable } from "./MenuDesplegable";
import { ACCESO_TRADUCTOR, ACCESO_ADMIN_TRADUCCIONES } from "../../Contantes/Constantes";
import { TraduccionesIcono } from "./IconosMenu";

export default function TraduccionesItem({ openMenu, addMenuItemView }) {
    const opciones = [
        {
            link: '/traducciones/solicitante',
            nombre: 'Solicitar Traducción',
            view: 'traducciones',
        },
        {
            link: '/traducciones/traductor',
            nombre: 'Traducciones Pendientes',
            rol: ACCESO_TRADUCTOR,
            view: 'traducciones'
        },
        {
            link: '/traducciones/admin',
            nombre: 'Administrar Traducciones',
            rol: ACCESO_ADMIN_TRADUCCIONES,
            view: 'traducciones'
        },
    ];

    return (
        <MenuDesplegable
            addMenuItemView={addMenuItemView}
            openMenu={openMenu}
            icon={<TraduccionesIcono />}
            modulo={'Traducciones'}
            opciones={opciones}
        />
    );
}
